import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Avatar, Box, Button, Divider, List, ListItemButton } from '@mui/material';
import { useContext } from 'react';
import { ToolContext } from '../../../../core/context/ToolContext';
import { rqx } from '../../../../core/request/API';
import { domain, env } from '../../../../core/Env';
import { LogoutIcons, SupportIcons, TcIcon } from '../../../../core/global/Icons';
import { NavigationBible } from '../../../bible/NavigationBible';
import moment from 'moment';

const tool_id =  process.env.REACT_APP_TID;

export const Index = () => {
    const __LOCATION = useLocation().pathname
    const nav = useHistory()
    const { navigation_state, tool_state, personalization_state, install_state, notif_state } = useContext(ToolContext)
    const { tc, prevURL } = navigation_state 
    const { openNotif } = notif_state
    const ps = personalization_state
    // eslint-disable-next-line
    const [tourData, setTourData ] = useState('')
    const pinfo = tool_state.__SESSION.data.pinfo[0]
    // eslint-disable-next-line
    const [showTourProfile, setShowTourProfile] = useState(false)
    
    const handleClick = async(e, name) => {
        if (name === 'Get App for Desktop' || name === 'Get App for Mobile') {
            install_state.ip.set({stat: true, prompt_type: 'install'})
        }else if(name === 'Support'){
            window.chaport.open();
        }else if(name === 'Tool Categories'){
            prevURL.set(window.location.pathname)
            nav.push('/tool-categories/subscribed')    
        }else if(name === 'Guidelines' || name === 'Policies') {
            nav.push('/policies/list')
        } else if(name ==='Speak Out'){
            nav.push('/speakout/concern/list')
        }
    }

    const logoutHandler = async () => {
        if (install_state.prompt.data !== null && !('serviceWorker' in navigator && window.matchMedia('(display-mode: standalone)').matches)) {
            install_state.ip.set({stat: true, prompt_type: 'logout'})
        } else {
            localStorage.removeItem('biz_session')
            window.location.href = `${domain('pm').url}/biz/login`

            let data = {
                action: "signout",
                aid: tool_state.__SESSION.data.ainfo.aid,
                date: moment(new Date()).format('YYYY-MM-DD'),
                tool_id: JSON.parse(tool_id)
            }
            await rqx.post(`<<global>>/${env()}/trail/create`, data)
        }
    }

    const __init = async() => {
        const user_id = atob(tool_state.__SESSION.data.ainfo.aid).split('_', 2)[1];
        let _res = ps.personalizationData.data.filter(v => {return v.feature_name === 'my-profile'} );
        let filter = ps.personalizationData.data.filter(v => {return v.feature_name !== 'my-profile'} );
        
        if (_res.length === 0) {
            setShowTourProfile(true)
            let data = {
                user_id:parseInt(user_id), 
                tool_id:parseInt(tool_id), 
                feature_name:'my-profile', 
                personalization:[
                    {sf_name:'tour-profile', status:1},
                ] 
            };
            setTourData(data)
            ps.personalizationData.set([...filter, ...[data]]);
            if (tool_state.__SESSION.data.uaddress.length > 0 && JSON.parse(tool_state.__SESSION.data.pinfo[0].other_info).gender !== null) {
                setShowTourProfile(false)
                await rqx.post(`<<global>>/${env()}/personalization/create`, data )
            }
        }else{
            setShowTourProfile(false)
            let data =  _res[0];
            ps.personalizationData.set([...filter, ...[data]]);
        }
    }

    const [subscribe, setSubscribe] = useState(true)
    useEffect(() => {
        if (subscribe) {
            __LOCATION === '/profile' && (
                tc.set({...tc.data, open: false, list: false})
            )
            if (!openNotif.data || (("Notification" in window) && Notification.permission !== 'default')) {
                __init()
            }
        } 
        return () => setSubscribe(false)
        // eslint-disable-next-line
    }, [openNotif.data])

    return (
        <Box width="100%" height="100%" display="flex" flexDirection="column" gap="37px" bgcolor="#FFFFFF">
            <Box component={Button} onClick={()=>nav.push('/profile?tabs=empinfo')} width="100%" height="91px" py="12px" px="16px" display="flex" justifyContent="flex-start" alignItems="center" gap="16px">
                <Avatar src={
                    JSON.parse(pinfo.profile).profile === null || JSON.parse(pinfo.profile).profile === '' ? 
                        'https://pofsis-business.s3.amazonaws.com/biz-image/1653891687343.jpg' 
                    : 
                        JSON.parse(pinfo.profile).profile 
                    }
                sx={{width:'56px', height:'56px'}}/>
                <Box display="flex" flexDirection="column" alignItems="flex-start" gap="4px" color="#283745">
                    {tool_state.__SESSION.data.pinfo.length === 0 ?
                        <Box fontSize="14px" fontWeight={600} lineHeight="23px">Hero User</Box>
                    :
                        <Box fontSize="14px" fontWeight={600} lineHeight="23px">{pinfo.first_name} {pinfo.last_name}</Box>
                    }
                    <Box fontSize="11px" fontWeight={400} lineHeight="19px">{tool_state.__SESSION.data.ainfo.email}</Box>
                    <Box fontSize="11px" fontWeight={400} lineHeight="19px">{tool_state.__SESSION.data.uaccess[0].role_id === 0 ? 'Business Account' : 'Work Account'}</Box>
                </Box>
            </Box>
            <Box height="100%" className="overflowY cstmscroll">
                <List>
                        {
                            navigation_state.tabs.data.msetting.map((t, k) => (
                                <Box key={k} height="48px" fontSize="14px" fontWeight={400} color="#283745" lineHeight="23px">
                                    <ListItemButton onClick={(e)=>handleClick(e, t.name)}  sx={{px:'16px !important', display:'flex', justifyContent:"space-between", alignItems:'center', gap:'12px'}} >
                                        <Box display="flex" alignItems="center" gap="12px">
                                            {__LOCATION.split('/')[1] === t.ref ? t.active : t.not_active}
                                            <Box color="#283745">{t.name}</Box>
                                        </Box>
                                    </ListItemButton>
                                </Box>
                            ))
                        }
                        <Box height="48px" fontSize="14px" fontWeight={400} color="#283745" lineHeight="23px">
                            <Box sx={{ px: '16px', height: '48px', display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <NavigationBible size={20} />
                                <Box color="#283745">Daily Guide Words</Box>
                            </Box>
                        </Box>
                        <Box height="48px" fontSize="14px" fontWeight={400} color="#283745" lineHeight="23px">
                            <ListItemButton onClick={(e)=>handleClick(e, 'Tool Categories')} sx={{px:'16px !important', display:'flex', justifyContent:"space-between", alignItems:'center', gap:'12px'}} >
                                <Box display="flex" alignItems="center" gap="12px">
                                    {__LOCATION.split('/')[1] === 'tool-categories' ? <TcIcon fill="#107038" stroke="#107038"/> : <TcIcon stroke={'#89A594'} fill={'#fff'} />}
                                    <Box color="#283745">Tool Categories</Box>
                                </Box>
                            </ListItemButton>
                        </Box>
                    </List>
            </Box>
            <Box px="16px">
                <Divider sx={{height:'1px', bgcolor:'#C9D6DF', p:'0px !important'}} />
            </Box>
            <Box height="96px" >
                <Box height="48px" fontSize="14px" fontWeight={400} color="#283745" lineHeight="23px">
                    <ListItemButton onClick={(e)=>handleClick(e, 'Support')} sx={{px:'16px !important', display:'flex', alignItems:'center', gap:'12px'}} >
                        <SupportIcons/>
                        Support
                    </ListItemButton>
                </Box>
                <Box height="48px" fontSize="14px" fontWeight={400} color="#283745" lineHeight="23px">
                    <ListItemButton onClick={(e)=>logoutHandler(e)} sx={{px:'16px !important', display:'flex', alignItems:'center', gap:'12px'}} >
                        <LogoutIcons/>
                        Logout
                    </ListItemButton>
                </Box>
            </Box>
            <Box minHeight={install_state.prompt.data !== null ? "64px" : "0px"} />
        </Box>
    )
}
